export default __webpack_public_path__ + "static/media/user_icon.1b41fe32.svg";